var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"rgb(0,0,0)"},[React.createElement("path",{"d":"m13 16.97h54v10h-54z","key":0}),React.createElement("path",{"d":"m13 35.97h54v10h-54z","key":1}),React.createElement("path",{"d":"m13 53.97h54v10h-54z","key":2})]));
}

Menu.defaultProps = {"id":"Layer_1","height":"512","viewBox":"0 0 80 80","width":"512","data-name":"Layer 1"};

module.exports = Menu;

Menu.default = Menu;
